import React, { useState, useCallback, useEffect } from 'react';
import { Box } from '@mui/material';

/**
 * QRCode - QR Code generator component
 * Generates QR codes using qrcode library with customizable styling
 *
 * @param {Object} props - Component props
 * @param {string} props.link - URL to encode in QR code
 * @param {Object} [props.sx] - MUI sx styling object
 * @param {...Object} props - Additional props passed to Box component
 * @returns {React.ReactElement} QR code image element
 */
const QRCode = ({ link, sx = {}, ...props }) => {
  const [dataUrl, setDataUrl] = useState();

  const generateCode = useCallback(
    async url => {
      try {
        const QRCodeGenerator = await import('qrcode');
        const result = await QRCodeGenerator.default.toDataURL(
          url,
          {
            errorCorrectionLevel: 'low',
            margin: 0,
            width: sx.width * 4 || 100,
            color: {
              dark: '#02568d',
            },
          },
        );
        setDataUrl(result);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('QR Code generation failed:', error);
      }
    },
    [sx.width],
  );

  useEffect(
    () => {
      if (link) {
        generateCode(link);
      }
    },
    [generateCode, link],
  );

  if (!dataUrl) {
    return null;
  }

  return (
    <Box
      component="img"
      src={dataUrl}
      alt="QR Code"
      {...sx}
      {...props}
    />
  );
};

QRCode.displayName = 'QRCode';

export default React.memo(QRCode);
